<template>
  <div class="lp-wrapper">
    <div class="main-content-container">
      <div class="main-content">
        <h1 class="title">
          Zbuduj plan ubezpieczeniowy dla siebie i swojej rodziny
        </h1>
        <div class="features-list">
          <div
            class="features-list__item"
            v-for="feature in features"
            :key="feature.icon"
          >
            <div
              class="features-list__icon"
              :class="feature.after ? 'after' : ''"
            >
              <md-icon :md-src="`/icons/${feature.icon}.svg`" />
            </div>
            <span class="features-list__label">{{ feature.text }}</span>
            <md-tooltip md-direction="bottom">{{ feature.tooltip }}</md-tooltip>
          </div>
        </div>
        <md-button @click="openModal" class="lp-btn md-info">
          Zaczynamy
        </md-button>
      </div>
    </div>
    <div class="img-area" :style="backgroundImg">
      <img src="/img/logo.png" alt="Discoveria" class="img-logo" />
    </div>
    <HomeModal ref="homeModal" />
  </div>
</template>

<script>
import HomeModal from '../components/HomeModal'

const images = {
  'd82bcefb-d44b-4028-9e6a-70bf8b3ac27b': 'external-bg-1.jpg',
}

export default {
  name: 'Home',
  components: {
    HomeModal,
  },
  created() {},
  methods: {
    openModal() {
      this.$refs.homeModal.open()
    },
  },
  computed: {
    backgroundImg() {
      const img = images[this.$route.query.refguid]
      if (img) {
        return {
          background: `url('/img/${img}') no-repeat right top / auto 100%`,
        }
      }
      return {
        background: `url('/img/lp-bg.jpg') no-repeat left top / auto 100%`,
      }
    },
  },
  data() {
    return {
      agreed: false,
      features: [
        {
          icon: 'today',
          text: 'Ustawiasz datę urodzenia',
          after: true,
          tooltip:
            'Potrzebujemy Twoją datę urodzenia by przybliżyć ' +
            'Ci miesięczny koszt Twojego planu ubezpieczeniowego. ' +
            'Oferta ubezpieczeniowa, którą prezentujemy w niniejszym serwisie ' +
            'dostępna jest dla osób z ukończonym 18 i nie ukończonym 63 rokiem życia.',
        },
        {
          icon: 'extension',
          tooltip:
            'Sam decydujesz, z jakich elementów złożony będzie Twój plan ubezpieczeniowy. Włączaj, wyłączaj kolejne produkty i ustawiaj ich parametry zgodnie ze swoimi potrzebami - natychmiast pokażemy Ci wstępną ich wycenę.',
          after: true,
          text: 'Konfigurujesz plan',
        },
        {
          icon: 'pdf',
          text: 'Wysyłamy Ci raport',
          after: true,
          tooltip:
            'Gdy ustawiłeś/aś optymalną dla siebie konfigurację planu ubezpieczeniowego i chcesz pójść dalej, zostawi nam kontakt do siebie. Wyślemy Ci szczegółowy raport i niezbędną dokumentację.',
        },
        {
          icon: 'headphones',
          text: 'Uruchamiamy Twój plan',
          after: false,
          tooltip:
            'Nasz Doradca skontaktuje się z Tobą, udzieli wszelkich niezbędnych wyjaśnień. ' +
            'Jeśli zdecydujesz się uruchomić swój plan ubezpieczeniowy, skoordynuje dalszy proces kompletowania i obiegu dokumentów. ' +
            'Dzisiaj możemy ten proces obsłużyć zdalnie.',
        },
      ],
    }
  },
}
</script>

<style scoped lang="scss">
.lp-wrapper {
  height: 100vh;
  display: flex;
  @media screen and (max-width: 599px) {
    height: 100%;
  }
}
.main-content {
  text-align: center;
  width: 557px;
  margin: 0 auto;
  @media screen and (max-width: 1440px) {
    width: 440px;
  }
  @media screen and (max-width: 1024px) {
    width: 557px;
  }
  @media screen and (max-width: 600px) {
    width: 300px;
  }
}
.main-content-container {
  width: 45%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
  border-right: 17px solid #f5841f;
  box-shadow: 33px 33px 55px rgba(255, 61, 0, 0.18);
  @media screen and (max-width: 1200px) {
  }
  @media screen and (max-width: 1024px) {
    border-right: 0;
    box-shadow: none;
    width: 100%;
  }
  @media screen and (max-width: 599px) {
    /*padding: 0 15px;*/
  }
}
.title {
  font-size: 2.5rem;
  width: 27ex;
  font-weight: 900;
  text-align: center;
  @media screen and (max-width: 1440px) {
    font-size: 1.9rem;
  }
  @media screen and (max-width: 1400px) {
    font-size: 1.6rem;
  }
  @media screen and (max-width: 768px) {
    margin-top: 60px;
  }
  @media screen and (max-width: 599px) {
    font-size: 1.3rem;
    margin-top: 83px;
  }
}
.features-list {
  text-align: left;
  width: 100%;
  @media screen and (max-width: 1024px) {
    width: auto;
  }
  &__item {
    display: flex;
    align-items: center;
    font-size: 22px;
    margin-top: 30px;
    @media screen and (max-width: 1440px) {
      font-size: 18px;
    }
    @media screen and (max-width: 1400px) {
      margin-top: 20px;
    }
    @media screen and (max-width: 1024px) {
      font-size: 22px;
    }
    @media screen and (max-width: 599px) {
      font-size: 12px;
      margin-top: 16px;
    }
    &:hover {
      cursor: pointer;
      .features-list__icon {
        border-color: transparent;
        &::before {
          border-color: #f5841f;
        }
      }
      .features-list__label {
        font-weight: 700;
      }
    }
  }
  &__label {
    margin-left: 16px;
    transition: font-weight 0.1s linear;
  }
  &__icon {
    position: relative;
    display: flex;
    transition: border-color 0.1s linear;
    align-items: center;
    justify-content: center;
    height: 80px;
    width: 80px;
    border: 3px solid #f5841f;
    border-radius: 50%;
    @media screen and (max-width: 1440px) {
      height: 60px;
      width: 60px;
    }
    @media screen and (max-width: 1024px) {
      height: 80px;
      width: 80px;
    }
    @media screen and (max-width: 599px) {
      height: 44px;
      width: 44px;
      border-width: 2px;
    }
    i {
      height: 41px;
      width: 41px;
      @media screen and (max-width: 1440px) {
        height: 30px;
        width: 30px;
      }
      @media screen and (max-width: 1024px) {
        height: 41px;
        width: 41px;
      }
      @media screen and (max-width: 599px) {
        height: 24px;
        width: 24px;
      }
    }
    &::before {
      display: block;
      position: absolute;
      transition: border-color 0.1s linear;
      top: -3px;
      left: -3px;
      content: '';
      z-index: 10;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      border: 3px dashed transparent;
      animation: spin 9s linear infinite;
      @media screen and (max-width: 1440px) {
        height: 60px;
        width: 60px;
      }
      @media screen and (max-width: 1025px) {
        height: 80px;
        width: 80px;
      }
      @media screen and (max-width: 599px) {
        top: -2px;
        left: -2px;
        width: 44px;
        height: 44px;
        border-width: 2px;
      }
    }
    &.after::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -1.5px;
      height: 28px;
      width: 4px;
      background-image: linear-gradient(#d5d5d5 50%, rgba(255, 255, 255, 0) 0%);
      background-position: right;
      background-size: 4px 15px;
      background-repeat: repeat-y;
      @media screen and (max-width: 1400px) {
        height: 20px;
        background-size: 4px 11px;
      }
      @media screen and (max-width: 599px) {
        width: 3px;
        height: 14px;
        background-size: 6px 7px;
      }
    }
  }
}
.agreement {
  text-align: left;
  font-size: 14px;
  margin-top: 56px;
  margin-bottom: 0;
  @media screen and (max-width: 1440px) {
    margin-top: 36px;
  }

  @media screen and (max-width: 1400px) {
    margin-top: 25px;
  }
  @media screen and (max-width: 1024px) {
    margin-top: 56px;
  }
  @media screen and (max-width: 599px) {
    font-size: 12px;
  }
  @media screen and (max-width: 360px) {
    margin-top: 20px;
    font-size: 10px;
  }
}
.lp-btn {
  margin-top: 30px;
  font-size: 1.3em;
  padding: 0 2em;
  @media screen and (max-width: 1440px) {
    font-size: 1rem;
  }
  @media screen and (max-width: 1400px) {
    margin-top: 0.8rem;
  }
  @media screen and (max-width: 1024px) {
    font-size: 1.3rem;
  }
  @media screen and (max-width: 599px) {
    font-size: 1rem;
  }
  @media screen and (max-width: 360px) {
    font-size: 0.6rem;
  }
}
.img-area {
  width: 55%;
  //background: url('/img/lp-bg.jpg') no-repeat left top;
  //background: url('/img/test.jpg') no-repeat right top;
  background-size: auto 100%;
  @media screen and (max-width: 1024px) {
    background: #f0802d;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    box-shadow: 0 6px 33px rgba(255, 61, 0, 0.18);
  }
  @media screen and (max-width: 599px) {
    height: 60px;
  }
}
.img-logo {
  margin: 30px 30px 0 0;
  float: right;
  max-width: 200px;
  @media screen and (max-width: 1024px) {
    float: none;
    display: block;
    margin: 15px auto;
  }
  @media screen and (max-width: 599px) {
    height: 40px;
    width: 60px;
    margin-top: 12px;
  }
}
@keyframes spin {
  0% {
    transform: rotateZ(0);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
</style>
